export class AdjustTaxes {
    public constructor(init?: Partial<AdjustTaxes>) {
      Object.assign(this, init);
    }
      invoiceNumber: string;
      adjustmentPostingId: number;
   }